import { deleteRequest, getRequest, postRequest } from 'features/common'
import { getClient } from 'features/common/utils/clientParameter'
import { JobClientModel } from './types'

export class JobsClient implements JobClientModel {
  constructor(private readonly apiUrl: string) {}

  create(connection, payload) {
    return postRequest(`${this.apiUrl}/${connection}/job?client=${getClient()}`, payload)
  }

  delete(connection, jobId) {
    return deleteRequest(`${this.apiUrl}/${connection}/job/${jobId}?client=${getClient()}`)
  }

  getStatus(connection, jobId, signal) {
    return getRequest(`${this.apiUrl}/${connection}/job/${jobId}?client=${getClient()}`, { signal })
  }
}
